import{useContext as o}from'react';import{ModalContext as t}from'../../components/modal/Modal/ModalContext.js';const m=()=>o(t);export{m as useModal};
